import { gql } from '@apollo/client';
import type { WorkflowSubStepsDefinition } from '@ovComponents/4-module/goalCard/goalRiskQuestionConfig';

export const FETCH_EMBEDDED_GOAL_WORKFLOW = gql`
  query fetchEmbeddedGoalWorkflow($workflowId: ObjectID!) {
    fetchWorkflow(workflowId: $workflowId) {
      workflow {
        steps {
          subSteps {
            type
            options
          }
        }
      }
    }
  }
`;

export type FetchEmbeddedGoalWorkflowQuery = {
  fetchWorkflow?: {
    workflow?: WorkflowSubStepsDefinition;
  };
};
